import React, { useState } from 'react';
import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Slide, Typography } from "@mui/material";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { Document } from '../../../../api/Endpoints/Document';
import SelectX from '../../../form/SelectX'
import TextInput from '../../../form/TextInput'
import DateInput from '../../../form/DateInput'
import { Departments } from '../../../../api/Endpoints/Departments';
import { Employee } from '../../../../api/Endpoints/Employee';
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import { ErrorMessage } from "@hookform/error-message";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from 'react';
import moment from 'moment';
import FileUpload from '../../../../components/FileUploader/index'
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const scheme = yup.object().shape({

    // document_name: yup.string().required("field is requried"),
    // email: yup.string().email(),
    // phone_number: yup.string(),
    // employee_roles_id: yup.object(),
    // address: yup.string(),
    // emergency_contacts: yup.string(),
    // joining_date: yup.date(),
    // remarks: yup.string(),
});


const Create = (props) => {
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, reset } = useForm({ resolver: yupResolver(scheme), criteriaMode: "all" });
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState(null);
    const handleClickOpen = () => {
        props.onNew()
    };

    const handleClose = () => {
        props.setEditId(undefined)
        setOpen(false);
    };

   

    const [formButtonStatus, setFormButtonStatus] = useState({
        label: "Submit",
        loading: false,
        disabled: false,
    });

    // const fetchOrganisations = (e) => {
    //     return Organisations.get({ keyword: e }).then(response => {
    //         if (typeof response.data.data.data !== "undefined") {
    //             return response.data.data.data;
    //         } else {
    //             return [];
    //         }
    //     })
    // }



    const onSubmit = (data) => {
        setFormButtonStatus({ ...formButtonStatus, loading: true });

        const fd = new FormData();
        fd.append('file', selectedFiles)

        console.log("this is fd", fd);
        const dataToSubmit = {
            users_id: 3911,
            title: data.title,
            remarks: data.remarks,
            document_category_id: 2,
            file: fd
        };
        console.log("data to submit", dataToSubmit);


        Document.add(dataToSubmit)
            .then((response) => {
                // Handle success
                setFormButtonStatus({ label: "Submitted", loading: false, disabled: true });
                setFormButtonStatus({ label: "Create", loading: false, disabled: false });

                if (response.data.errors) {
                    toast.error("The email or phone number has already been taken");
                    return;
                }

                toast.success(response.data.message);
                props.onUpdate();
                setOpen(false);
            })
            .catch((errors) => {
                // Handle error
                toast.error("Internal server error");
                setFormButtonStatus({ label: "Create", loading: false, disabled: false });
                setOpen(false);
            });
    };

    useEffect(() => {
        if (parseInt(props.editId) > 0) {
            setOpen(true);
        } else if (Number(props.editId) === 0) {
            setOpen(true);
        }

    }, [])

    return (
        <div>
            <Button className='create-btn' variant="contained" onClick={handleClickOpen} sx={{ mt: 2 }}>
                {props.icon ? <AddIcon style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }} /> : "Add Document"}
            </Button>
            <Dialog
                open={open}
                PaperProps={{ sx: { width: "100%", height: "100%", position: "fixed", right: 0, top: 0, bottom: 0, m: 0, p: 0, borderRadius: 0, maxHeight: '100%' } }}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle >{parseInt(props.editId) > 0 ? "Edit Employee" : "Add Document"}</DialogTitle>
                <DialogContent>


                    <Grid container sx={{ mt: 2 }}>

                        <Grid item xs={12} sm={12}>


                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid container>


                                    <Grid sx={{ p: 1 }} item xs={12}>
                                        <TextInput control={control} name="title"
                                            label="Document Name"
                                            value={watch('title')}
                                        />
                                    </Grid>

                                    <Grid sx={{ p: 1 }} item xs={12}>
                                        <FileUpload selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} />
                                    </Grid>
                                    <Grid sx={{ p: 1 }} item xs={12}  >
                                        <TextInput control={control} name="description"
                                            label="Description"
                                            value={watch('description')}
                                            row={4}
                                            isMultiline />
                                    </Grid>
                                    <Grid sx={{ p: 1 }} item xs={12}  >
                                        <TextInput control={control} name="remarks"
                                            label="Remarks"
                                            value={watch('remarks')}
                                            row={4}
                                            isMultiline />
                                    </Grid>
                                    <Grid sx={{ p: 1 }} item xs={12}>
                                        <ErrorMessage
                                            errors={errors}
                                            name="multipleErrorInput"
                                            render={({ messages }) =>
                                                messages &&
                                                Object.entries(messages).map(([type, message]) => (
                                                    <p key={type}>{message}</p>
                                                ))
                                            }
                                        />

                                        <LoadingButton loading={formButtonStatus.loading} disabled={formButtonStatus.disabled}
                                            variant="outlined" type="submit">{formButtonStatus.label}</LoadingButton>
                                    </Grid>
                                </Grid>
                            </form>





                        </Grid>
                        <Grid item xs={4}>

                        </Grid>


                    </Grid>



                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div >
    );
};

export default Create;
